<template>
  <div class="page">
    <img class="propertyInfoBg" src="../../../../assets/house/property/propertyInfoBg.png" alt="">
    <div class="sechout">
      <div class="sech-left" @click="back()">
        <van-icon style="padding-left:15px" name="arrow-left" color="#181616" size="20" />
      </div>
      <div class="sech-title">物业信息</div>
      <div class="sech-right"></div>
    </div>
    <van-row type="flex" justify="center">
      <van-col span="22">
        <div class="form">
          <div class="form_group">
            <div class="form_item">
              <div class="form_item_key">姓名</div>
              <div class="form_item_val">销巴房产</div>
            </div>
            <div class="form_item">
              <div class="form_item_key">身份</div>
              <div class="form_item_val">租客</div>
            </div>
            <div class="form_item">
              <div class="form_item_key">电话</div>
              <div class="form_item_val">182××××××××</div>
            </div>
            <div class="form_item">
              <div class="form_item_key">住址</div>
              <div class="form_item_val">阳光城上府1区1幢1单元1011</div>
            </div>
            <div class="form_item">
              <div class="form_item_key">租期</div>
              <div class="form_item_val">2021.05.21 -2022.05.20</div>
            </div>
          </div>
          <div class="btn" @click="toEdit()">修改</div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  export default {
    methods: {
      toEdit() {
        this.$router.push('/house/property/binding1')
      },
      back() {
        this.$router.go(-1);
      },
    },
  }
</script>

<style lang="less" scoped>
  .page {
    background-color: #f5f5f5;
    height: 100%;
    position: relative;
  }

  .sechout {
    position: absolute;
    top: 22px;
    left: 0;
    height: 44px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    // flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .sech-title {
    font-size: 17px;
    font-weight: 500;
    color: #222325;
  }

  .propertyInfoBg {
    width: 100%;
  }

  .form {
    transform: translateY(-74px);
  }

  .form_group {
    padding: 12px 24px;
    border-radius: 6px;
    background-color: #ffffff;

  }

  .form_item {
    height: 44px;
    display: flex;
    align-items: center;
  }

  .form_item_key {
    width: 48px;
    font-size: 14px;
    font-weight: 400;
    color: #B3B9BF;
  }

  .form_item_val {
    font-size: 14px;
    font-weight: 400;
    color: #222325;
  }

  .btn {
    height: 48px;
    background: #FFFFFF;
    border-radius: 6px;
    margin-top: 12px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-weight: 400;
    color: #FF6030;
  }
</style>